@if (data) {
  <rt-feature-tooltip
    [arrowPosition]="arrowPosition"
    [isNew]="data.isNew"
    [title]="data.title"
    [description]="data.description"
    [learnMore]="data.learnMore"
    [learnMoreCopy]="data.learnMoreCopy"
    [ctaText]="data.ctaText"
    (learnMoreClick)="learnMoreClick$.emit()"
    (ctaClick)="ctaClick$.emit()"
    (close)="close$.emit()"
  ></rt-feature-tooltip>
}
